import { createApp, h } from 'vue'
import App from '@/App.vue'
import router from './router'
import store, { key } from './store/store'
import application from '@/mixins/application/application'
import { configureClient } from '@/hexapla-core/client'
import { ActionTypes } from '@/store/actions'

// A 401 outside login means the session is gone — expired, or replaced by a
// sign-in elsewhere. End it and return to the login screen. Ending a session is
// not signing out: the lemma in progress is kept for the same contributor to
// pick up after signing back in (see SESSION_ENDED).
//
// Requests in flight usually 401 together. Only the first redirects: a later
// one finds no token and, without this flag, would push a bare /login over the
// pending `?session=expired` navigation. Cleared once the login screen shows.
let redirectingToLogin = false

router.afterEach((to) => {
  if (to.path === '/login') redirectingToLogin = false
})

configureClient(
  () => store.state.user.token,
  () => {
    if (redirectingToLogin) return

    const hadSession = Boolean(store.state.user.token)
    if (hadSession) store.dispatch(ActionTypes.END_SESSION)
    if (router.currentRoute.value.path === '/login') return

    redirectingToLogin = true
    router.push({ path: '/login', query: hadSession ? { session: 'expired' } : {} }).catch(() => {
      redirectingToLogin = false
    })
  }
)

createApp({
  provide: {
    application,
  },
  render: () => h(App),
})
  .use(router)
  .use(store, key)
  .mount('#app')
